<template>
  <li class="p-0 m-0">
    <NuxtLink
      :to="formattedSubCategoryLink"
      class="text-[16px] sm:text-[15px] flex items-center justify-between gap-0.5 3xl:text-[15.5px] font-normal"
    >
      <span :title="nestedItem[nameKey]">
        {{
        nestedItem[nameKey] }}
      </span>
      <!-- Lazy loaded content -->
      <div class="lazy-load w-[24px] h-[24px] bg-slate-200 rounded-full bg-contain" :data-alt="nestedItem[nameKey]" :data-src="(nestedItem.image) && (nestedItem.image).replaceAll(' ', '%20')" />
    </NuxtLink>
  </li>
</template>

<script>

export default {
  props: {
    nestedItem: {
      type: Object,
      default: () => ({}),
      required: true
    },
    item: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    formattedSubCategoryLink() {
      try{
        let queryToUrl = `${`&main_category_id=${this.item?.id}`}${`&category_id=${this.nestedItem?.id}`}${`&from=list`}`.replace(/^&/, "");
        let encodedQuery = btoa(encodeURIComponent(queryToUrl));
        return `${this.ROUTESNAMES.user.products}?${encodedQuery}`;
      }catch{
        return `${this.ROUTESNAMES.user.products}`;
      }
    }
  },
};
</script>

<style>
</style>